<template>
  <div class="radio-group">
    <div
      v-for="(item, idx) in buttonEnum"
      :key="idx"
      class="radio-group-button"
      :class="{ active: buttonState.length > 0 && buttonState[idx].isSelected }"
      @click="buttonClick(idx)"
    >
      <span>{{ item.title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioButtonGroup',
  props: {
    defaultVale: {
      type: String,
      default: ''
    },
    buttonEnum: {
      type: Array
    },
    mutiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      buttonState: []
    }
  },
  watch: {
    buttonEnum(_curvalue, _newval) {
      this.init()
    }
  },
  methods: {
    init() {
      this.buttonState = this.buttonEnum.map((item) => {
        if (this.defaultVale !== '' && item.questionType === this.defaultVale) {
          return { isSelected: true, ...item }
        }
        return { isSelected: false, ...item }
      })
    },
    buttonClick(index) {
      // 多选
      if (this.mutiple) {
        this.buttonState = this.buttonState.map((item, idx) => {
          if (index !== idx) return item
          const { isSelected, ...otherParams } = item
          return { isSelected: !isSelected, ...otherParams }
        })
      } else {
        // 单选
        const curIsSelected = this.buttonState[index].isSelected
        if (curIsSelected) return // 点击已选中的直接返回
        this.buttonState = this.buttonState.map((item, idx) => {
          const { isSelected, ...otherParams } = item
          if (index !== idx) {
            return { isSelected: curIsSelected, ...otherParams }
          }
          return { isSelected: !curIsSelected, ...otherParams }
        })
      }
      const result = this.buttonState.filter((item) => item.isSelected)
      console.log('-------------------result', result)
      this.$emit('on-change', result)
    }
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
